/* eslint-disable react/jsx-handler-names */
"use client";
import React, { useRef, useEffect, useState } from "react";
import CustomImage from "../../atoms/customImage";
import PropTypes from "prop-types";
import Drawer from "../drawer";

/**
 * Information Button Component that displays a button.
 * @returns {JSX.Element} - Rendered component.
 */
const Index = ({ renderInformation, isMobile, icon }) => {
  const buttonRef = useRef(false);
  const [informationVisible, setInformationVisible] = useState(false);

  /**
   * Handles the mouse leave event, hiding the information tooltip.
   * Sets the visibility state to false.
   */
  const handleMouseLeave = () => setInformationVisible(false);

  /**
   * Handles the mouse enter event, showing the information tooltip.
   * Sets the visibility state to true.
   */
  const handleMouseEnter = () => setInformationVisible(true);

  useEffect(() => {
    const button = buttonRef.current;

    if (button && !isMobile) {
      button.addEventListener("mouseleave", handleMouseLeave);
      button.addEventListener("mouseenter", handleMouseEnter);
    }

    return () => {
      if (button && !isMobile) {
        button.removeEventListener("mouseleave", handleMouseLeave);
        button.removeEventListener("mouseenter", handleMouseEnter);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Toggles the visibility of the information section.
   * @returns {void}
   */
  const onHandleVisibility = () => {
    setInformationVisible((e) => !e);
  };

  return (
    <>
      {isMobile ? (
        <Drawer
          position="bottom"
          isOpen={informationVisible}
          onDrawerClose={() => setInformationVisible(false)}
          styles={"p-0"}
        >
          {renderInformation}
        </Drawer>
      ) : (
        informationVisible && (
          <div className="absolute top-5 z-50 mx-auto w-fit  min-w-[300px] rounded-2xl  bg-white-900 p-16 shadow-[0_0px_6px_rgba(0,0,0,0.2)]  md:-left-30 md:top-0 md:mt-40">
            <div className="bg-white absolute -top-10 left-32 h-20 w-20 rotate-45 bg-white-900 shadow-[-4px_-3px_4px_rgba(0,0,0,0.1)]" />
            {renderInformation !== undefined && renderInformation}
          </div>
        )
      )}
      <button
        onClick={() => (isMobile ? setInformationVisible(true) : onHandleVisibility())}
        ref={buttonRef}
        aria-label="info"
        className="flex h-5 w-5 items-center justify-center rounded-full focus:outline-none"
      >
        <CustomImage src={icon} width={16} height={16} alt="" sizes="10vw" isPriority={false} />
      </button>
    </>
  );
};

Index.propTypes = {
  renderInformation: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,
};

export default Index;
